<template>
  <vx-card no-shadow>
    <div>
      <skeleton-box height="30px" width="200px"></skeleton-box>
      <skeleton-box height="30px" class="w-full mt-5"></skeleton-box>
      <skeleton-box height="30px" class="w-full mt-2"></skeleton-box>
      <skeleton-box height="30px" class="w-full mt-2"></skeleton-box>
      <skeleton-box height="30px" class="w-full mt-2"></skeleton-box>
      <skeleton-box height="30px" class="w-full mt-2"></skeleton-box>
    </div>
  </vx-card>
</template>

<script>
import SkeletonBox from "../../../../components/SkeletonBox.vue";
export default {
  components: {
    SkeletonBox,
  },
  data() {
    return {
      username: "johny_01",
      name: this.$store.state.AppActiveUser.displayName,
      email: "john@admin.com",
      company: "SnowMash Technologies Pvt Ltd",
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
};
</script>
